import { TermsStep } from '@features/FindSpecialist';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { motion } from 'framer-motion';
import { FC, useEffect } from 'react';
import { useMonitoringStore } from 'services/monitoring';

export const MonitoringV2Terms: FC = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { initialStepData } = useMonitoringStore();

	// Check if we have initial data, if not redirect to packages
	useEffect(() => {
		if (!initialStepData.id) {
			navigateWithLanguage('/farmer/services/monitoring-v2/packages');
		}
	}, [initialStepData.id, navigateWithLanguage]);

	// Override navigation to redirect to monitoring-v2 payment
	useEffect(() => {
		// Monkey patch history methods to intercept navigation
		const originalPushState = window.history.pushState;
		const originalReplaceState = window.history.replaceState;

		// Monkey patch history.pushState
		window.history.pushState = function (state, title, url) {
			// Only intercept if we're already in the monitoring-v2 flow
			if (
				url &&
				typeof url === 'string' &&
				window.location.pathname.includes('monitoring-v2') &&
				url.includes('/monitoring/payment') &&
				!url.includes('monitoring-v2/payment')
			) {
				url = url.replace('/monitoring/payment', '/monitoring-v2/payment');
			}
			return originalPushState.call(this, state, title, url);
		};

		// Monkey patch history.replaceState
		window.history.replaceState = function (state, title, url) {
			// Only intercept if we're already in the monitoring-v2 flow
			if (
				url &&
				typeof url === 'string' &&
				window.location.pathname.includes('monitoring-v2') &&
				url.includes('/monitoring/payment') &&
				!url.includes('monitoring-v2/payment')
			) {
				url = url.replace('/monitoring/payment', '/monitoring-v2/payment');
			}
			return originalReplaceState.call(this, state, title, url);
		};

		// Cleanup function to restore original behavior
		return () => {
			window.history.pushState = originalPushState;
			window.history.replaceState = originalReplaceState;
		};
	}, []);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{
				opacity: 1,
				transition: {
					duration: 0.5,
				},
			}}
			className="monitoring-v2-page"
			style={{ overflow: 'visible', height: 'auto' }}
		>
			<TermsStep />
		</motion.div>
	);
};
